import styles from './Form.module.css';
import React from "react";
function Form() {
  return (
    <div>

        <div style={{background: '#276A9F', height: 5}}></div>
        <div style={{background: '#14496B'}}>

            <div className="wrapperSlim">
                <div className={styles.header}>Sie haben Fragen?</div>
                <div className="grid">
                    <div className="lg:col-6 col-12">
                        <div className={styles.text}>Lassen Sie uns persönlich über Ihr Thema sprechen und gemeinsam die optimale Lösung für Sie finden.</div>
                        <br/>

                        <a href="tel://061113743283" style={{textDecoration: 'none'}}>
                            <div className={styles.phone}>+49 611 13743283</div>
                        </a>
                    </div>
                    <div className="lg:col-6 col-12">
                        <div style={{textAlign: 'right'}}>
                        </div>
                    </div>

                </div>

                <center>
                    <span className={styles.link} onClick={() => window.location.href = "/kontakt"}>Kontakt</span>
                    <span style={{color: '#FFFFFF'}}> · </span>
                    <span className={styles.link} onClick={() => window.location.href = "/impressum"}>Impressum</span>
                    <span style={{color: '#FFFFFF'}}> · </span>
                    <span className={styles.link} onClick={() => window.location.href = "/datenschutz"}>Datenschutz</span>
                </center>
            </div>
        </div>
        <div style={{background: '#276A9F', padding: 10, color: '#FFFFFF', textAlign: 'center'}}>
            Copyright © 2025
        </div>
    </div>
  );
}

export default Form;
